import { IPhoneNumber } from 'ui/Phone/types';

const numbers: IPhoneNumber[] = [
  {
    name: 'Afghanistan',
    iso: '+93',
    countryCode: 'AF',
    mask: '##-###-####',
  },
  {
    name: 'Åland Islands',
    iso: '+358',
    countryCode: 'AX',
    mask: '(###) ###-####',
  },
  {
    name: 'Albania',
    iso: '+355',
    countryCode: 'AL',
    mask: '(###) ###-###',
  },
  {
    name: 'Algeria',
    iso: '+213',
    countryCode: 'DZ',
    mask: '##-###-####',
  },
  {
    name: 'American Samoa',
    iso: '+1(684)',
    countryCode: 'AS',
    mask: '###-####',
  },
  {
    name: 'Andorra',
    iso: '+376',
    countryCode: 'AD',
    mask: '###-###',
  },
  {
    name: 'Angola',
    iso: '+244',
    countryCode: 'AO',
    mask: '(###) ###-###',
  },
  {
    name: 'Anguilla',
    iso: '+1(264)',
    countryCode: 'AI',
    mask: '###-####',
  },
  {
    name: 'Antarctica',
    iso: '+672',
    countryCode: 'AQ',
    mask: '###-###',
  },
  {
    name: 'Antigua and Barbuda',
    iso: '+1(268)',
    countryCode: 'AG',
    mask: '###-####',
  },
  {
    name: 'Argentina',
    iso: '+54',
    countryCode: 'AR',
    mask: '(###) ###-####',
  },
  {
    name: 'Armenia',
    iso: '+374',
    countryCode: 'AM',
    mask: '##-###-###',
  },
  {
    name: 'Aruba',
    iso: '+297',
    countryCode: 'AW',
    mask: '###-####',
  },
  {
    name: 'Australia',
    iso: '+61',
    countryCode: 'AU',
    mask: '#-####-####',
  },
  {
    name: 'Austria',
    iso: '+43',
    countryCode: 'AT',
    mask: '(###)###-####',
  },
  {
    name: 'Azerbaijan',
    iso: '+994',
    countryCode: 'AZ',
    mask: '##-###-##-##',
  },
  {
    name: 'Bahamas',
    iso: '+1(242)',
    countryCode: 'BS',
    mask: '###-####',
  },
  {
    name: 'Bahrain',
    iso: '+973',
    countryCode: 'BH',
    mask: '####-####',
  },
  {
    name: 'Bangladesh',
    iso: '+880',
    countryCode: 'BD',
    mask: '####-###-###',
  },
  {
    name: 'Barbados',
    iso: '+1(246)',
    countryCode: 'BB',
    mask: '###-####',
  },
  {
    name: 'Belarus',
    iso: '+375',
    countryCode: 'BY',
    mask: '(##)###-##-##',
  },
  {
    name: 'Belgium',
    iso: '+32',
    countryCode: 'BE',
    mask: '(###)###-###',
  },
  {
    name: 'Belize',
    iso: '+501',
    countryCode: 'BZ',
    mask: '###-####',
  },
  {
    name: 'Benin',
    iso: '+229',
    countryCode: 'BJ',
    mask: '##-##-####',
  },
  {
    name: 'Bermuda',
    iso: '+1(441)',
    countryCode: 'BM',
    mask: '###-####',
  },
  {
    name: 'Bhutan',
    iso: '+975',
    countryCode: 'BT',
    mask: '#-###-###',
  },
  {
    name: 'Bolivia, Plurinational State of bolivia',
    iso: '+591',
    countryCode: 'BO',
    mask: '#-###-####',
  },
  {
    name: 'Bosnia and Herzegovina',
    iso: '+387',
    countryCode: 'BA',
    mask: '##-#####',
  },
  {
    name: 'Botswana',
    iso: '+267',
    countryCode: 'BW',
    mask: '##-###-###',
  },
  {
    name: 'Bouvet Island',
    iso: '+47',
    countryCode: 'BV',
    mask: '(###) ###-####',
  },
  {
    name: 'Brazil',
    iso: '+55',
    countryCode: 'BR',
    mask: '(##)###-###-###',
  },
  {
    name: 'British Indian Ocean Territory',
    iso: '+246',
    countryCode: 'IO',
    mask: '###-####',
  },
  {
    name: 'Brunei Darussalam',
    iso: '+673',
    countryCode: 'BN',
    mask: '###-####',
  },
  {
    name: 'Bulgaria',
    iso: '+359',
    countryCode: 'BG',
    mask: '(###)###-###',
  },
  {
    name: 'Burkina Faso',
    iso: '+226',
    countryCode: 'BF',
    mask: '##-##-####',
  },
  {
    name: 'Burundi',
    iso: '+257',
    countryCode: 'BI',
    mask: '##-##-####',
  },
  {
    name: 'Cambodia',
    iso: '+855',
    countryCode: 'KH',
    mask: '##-###-###',
  },
  {
    name: 'Cameroon',
    iso: '+237',
    countryCode: 'CM',
    mask: '####-####',
  },
  {
    name: 'Canada',
    iso: '+1',
    countryCode: 'CA',
    mask: '(###)###-####',
  },
  {
    name: 'Cape Verde',
    iso: '+238',
    countryCode: 'CV',
    mask: '(###)##-##',
  },
  {
    name: 'Cayman Islands',
    iso: '+1(345)',
    countryCode: 'KY',
    mask: '###-####',
  },
  {
    name: 'Central African Republic',
    iso: '+236',
    countryCode: 'CF',
    mask: '##-##-####',
  },
  {
    name: 'Chad',
    iso: '+235',
    countryCode: 'TD',
    mask: '##-##-##-##',
  },
  {
    name: 'Chile',
    iso: '+56',
    countryCode: 'CL',
    mask: '#-####-####',
  },
  {
    name: 'China',
    iso: '+86',
    countryCode: 'CN',
    mask: '(###)####-####',
  },
  {
    name: 'Christmas Island',
    iso: '+61',
    countryCode: 'CX',
    mask: '(###) ###-####',
  },
  {
    name: 'Cocos (Keeling) Islands',
    iso: '+61',
    countryCode: 'CC',
    mask: '(###) ###-####',
  },
  {
    name: 'Colombia',
    iso: '+57',
    countryCode: 'CO',
    mask: '(###)###-####',
  },
  {
    name: 'Comoros',
    iso: '+269',
    countryCode: 'KM',
    mask: '##-#####',
  },
  {
    name: 'Congo',
    iso: '+242',
    countryCode: 'CG',
    mask: '##-###-####',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    iso: '+243',
    countryCode: 'CD',
    mask: '(###)###-###',
  },
  {
    name: 'Cook Islands',
    iso: '+682',
    countryCode: 'CK',
    mask: '##-###',
  },
  {
    name: 'Costa Rica',
    iso: '+506',
    countryCode: 'CR',
    mask: '####-####',
  },
  {
    name: "Cote d'Ivoire",
    iso: '+225',
    countryCode: 'CI',
    mask: '##-###-###',
  },
  {
    name: 'Croatia',
    iso: '+385',
    countryCode: 'HR',
    mask: '##-###-###',
  },
  {
    name: 'Cuba',
    iso: '+53',
    countryCode: 'CU',
    mask: '#-###-####',
  },
  {
    name: 'Cyprus',
    iso: '+357',
    countryCode: 'CY',
    mask: '##-###-###',
  },
  {
    name: 'Czech Republic',
    iso: '+420',
    countryCode: 'CZ',
    mask: '(###)###-###',
  },
  {
    name: 'Denmark',
    iso: '+45',
    countryCode: 'DK',
    mask: '##-##-##-##',
  },
  {
    name: 'Djibouti',
    iso: '+253',
    countryCode: 'DJ',
    mask: '##-##-##-##',
  },
  {
    name: 'Dominica',
    iso: '+1(767)',
    countryCode: 'DM',
    mask: '###-####',
  },
  {
    name: 'Dominican Republic',
    iso: '+1(849)',
    countryCode: 'DO',
    mask: '###-####',
  },
  {
    name: 'Ecuador',
    iso: '+593',
    countryCode: 'EC',
    mask: '##-###-####',
  },
  {
    name: 'Egypt',
    iso: '+20',
    countryCode: 'EG',
    mask: '(###)###-####',
  },
  {
    name: 'El Salvador',
    iso: '+503',
    countryCode: 'SV',
    mask: '##-##-####',
  },
  {
    name: 'Equatorial Guinea',
    iso: '+240',
    countryCode: 'GQ',
    mask: '##-###-####',
  },
  {
    name: 'Eritrea',
    iso: '+291',
    countryCode: 'ER',
    mask: '#-###-###',
  },
  {
    name: 'Estonia',
    iso: '+372',
    countryCode: 'EE',
    mask: '(###) ###-####',
  },
  {
    name: 'Ethiopia',
    iso: '+251',
    countryCode: 'ET',
    mask: '##-###-####',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    iso: '+500',
    countryCode: 'FK',
    mask: '#####',
  },
  {
    name: 'Faroe Islands',
    iso: '+298',
    countryCode: 'FO',
    mask: '###-###',
  },
  {
    name: 'Fiji',
    iso: '+679',
    countryCode: 'FJ',
    mask: '##-#####',
  },
  {
    name: 'Finland',
    iso: '+358',
    countryCode: 'FI',
    mask: '(###) ###-##-##',
  },
  {
    name: 'France',
    iso: '+33',
    countryCode: 'FR',
    mask: '(###) ###-###',
  },
  {
    name: 'French Guiana',
    iso: '+594',
    countryCode: 'GF',
    mask: '#####-####',
  },
  {
    name: 'French Polynesia',
    iso: '+689',
    countryCode: 'PF',
    mask: '##-##-##',
  },
  {
    name: 'French Southern Territories',
    iso: '+262',
    countryCode: 'TF',
    mask: '(###) ###-####',
  },
  {
    name: 'Gabon',
    iso: '+241',
    countryCode: 'GA',
    mask: '#-##-##-##',
  },
  {
    name: 'Gambia',
    iso: '+220',
    countryCode: 'GM',
    mask: '(###) ##-##',
  },
  {
    name: 'Georgia',
    iso: '+995',
    countryCode: 'GE',
    mask: '(###) ###-###',
  },
  {
    name: 'Germany',
    iso: '+49',
    countryCode: 'DE',
    mask: '(###) ###-#####',
  },
  {
    name: 'Ghana',
    iso: '+233',
    countryCode: 'GH',
    mask: '(###) ###-###',
  },
  {
    name: 'Gibraltar',
    iso: '+350',
    countryCode: 'GI',
    mask: '###-#####',
  },
  {
    name: 'Greece',
    iso: '+30',
    countryCode: 'GR',
    mask: '(###)###-####',
  },
  {
    name: 'Greenland',
    iso: '+299',
    countryCode: 'GL',
    mask: '##-##-##',
  },
  {
    name: 'Grenada',
    iso: '+1(473)',
    countryCode: 'GD',
    mask: '###-####',
  },
  {
    name: 'Guadeloupe',
    iso: '+590',
    countryCode: 'GP',
    mask: '(###) ###-####',
  },
  {
    name: 'Guam',
    iso: '+1(671)',
    countryCode: 'GU',
    mask: '###-####',
  },
  {
    name: 'Guatemala',
    iso: '+502',
    countryCode: 'GT',
    mask: '#-###-####',
  },
  {
    name: 'Guernsey',
    iso: '+44',
    countryCode: 'GG',
    mask: '(###) ###-####',
  },
  {
    name: 'Guinea',
    iso: '+224',
    countryCode: 'GN',
    mask: '##-###-###',
  },
  {
    name: 'Guinea-Bissau',
    iso: '+245',
    countryCode: 'GW',
    mask: '#-######',
  },
  {
    name: 'Guyana',
    iso: '+592',
    countryCode: 'GY',
    mask: '###-####',
  },
  {
    name: 'Haiti',
    iso: '+509',
    countryCode: 'HT',
    mask: '##-##-####',
  },
  {
    name: 'Heard Island and Mcdonald Islands',
    iso: '+0',
    countryCode: 'HM',
    mask: '(###) ###-####',
  },
  {
    name: 'Holy See (Vatican City State)',
    iso: '+379',
    countryCode: 'VA',
    mask: '#-###-#####',
  },
  {
    name: 'Honduras',
    iso: '+504',
    countryCode: 'HN',
    mask: '####-####',
  },
  {
    name: 'Hong Kong',
    iso: '+852',
    countryCode: 'HK',
    mask: '####-####',
  },
  {
    name: 'Hungary',
    iso: '+36',
    countryCode: 'HU',
    mask: '(###)###-###',
  },
  {
    name: 'Iceland',
    iso: '+354',
    countryCode: 'IS',
    mask: '###-####',
  },
  {
    name: 'India',
    iso: '+91',
    countryCode: 'IN',
    mask: '(####)###-###',
  },
  {
    name: 'Indonesia',
    iso: '+62',
    countryCode: 'ID',
    mask: '(###)###-###',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    iso: '+98',
    countryCode: 'IR',
    mask: '(###)###-####',
  },
  {
    name: 'Iraq',
    iso: '+964',
    countryCode: 'IQ',
    mask: '(###)###-####',
  },
  {
    name: 'Ireland',
    iso: '+353',
    countryCode: 'IE',
    mask: '(###)###-###',
  },
  {
    name: 'Isle of Man',
    iso: '+44',
    countryCode: 'IM',
    mask: '(###) ###-####',
  },
  {
    name: 'Israel',
    iso: '+972',
    countryCode: 'IL',
    mask: '#-###-####',
  },
  {
    name: 'Italy',
    iso: '+39',
    countryCode: 'IT',
    mask: '(###)####-###',
  },
  {
    name: 'Jamaica',
    iso: '+1(876)',
    countryCode: 'JM',
    mask: '###-####',
  },
  {
    name: 'Japan',
    iso: '+81',
    countryCode: 'JP',
    mask: '(###)###-###',
  },
  {
    name: 'Jersey',
    iso: '+44',
    countryCode: 'JE',
    mask: '(###) ###-####',
  },
  {
    name: 'Jordan',
    iso: '+962',
    countryCode: 'JO',
    mask: '#-####-####',
  },
  {
    name: 'Kazakhstan',
    iso: '+7',
    countryCode: 'KZ',
    mask: '(###)###-##-##',
  },
  {
    name: 'Kenya',
    iso: '+254',
    countryCode: 'KE',
    mask: '###-######',
  },
  {
    name: 'Kiribati',
    iso: '+686',
    countryCode: 'KI',
    mask: '##-###',
  },
  {
    name: "Korea, Democratic People's Republic of Korea",
    iso: '+850',
    countryCode: 'KP',
    mask: '###-####-###',
  },
  {
    name: 'Korea, Republic of South Korea',
    iso: '+82',
    countryCode: 'KR',
    mask: '##-####-####',
  },
  {
    name: 'Kosovo',
    iso: '+383',
    countryCode: 'XK',
    mask: '(###) ###-####',
  },
  {
    name: 'Kuwait',
    iso: '+965',
    countryCode: 'KW',
    mask: '####-####',
  },
  {
    name: 'Kyrgyzstan',
    iso: '+996',
    countryCode: 'KG',
    mask: '(###)###-###',
  },
  {
    name: 'Laos',
    iso: '+856',
    countryCode: 'LA',
    mask: '##-###-###',
  },
  {
    name: 'Latvia',
    iso: '+371',
    countryCode: 'LV',
    mask: '##-###-###',
  },
  {
    name: 'Lebanon',
    iso: '+961',
    countryCode: 'LB',
    mask: '##-###-###',
  },
  {
    name: 'Lesotho',
    iso: '+266',
    countryCode: 'LS',
    mask: '#-###-####',
  },
  {
    name: 'Liberia',
    iso: '+231',
    countryCode: 'LR',
    mask: '##-###-###',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    iso: '+218',
    countryCode: 'LY',
    mask: '##-###-###',
  },
  {
    name: 'Liechtenstein',
    iso: '+423',
    countryCode: 'LI',
    mask: '(###)###-####',
  },
  {
    name: 'Lithuania',
    iso: '+370',
    countryCode: 'LT',
    mask: '(###)##-###',
  },
  {
    name: 'Luxembourg',
    iso: '+352',
    countryCode: 'LU',
    mask: '(###)###-###',
  },
  {
    name: 'Macao',
    iso: '+853',
    countryCode: 'MO',
    mask: '####-####',
  },
  {
    name: 'Macedonia',
    iso: '+389',
    countryCode: 'MK',
    mask: '##-###-###',
  },
  {
    name: 'Madagascar',
    iso: '+261',
    countryCode: 'MG',
    mask: '##-##-#####',
  },
  {
    name: 'Malawi',
    iso: '+265',
    countryCode: 'MW',
    mask: '#-####-####',
  },
  {
    name: 'Malaysia',
    iso: '+60',
    countryCode: 'MY',
    mask: '(###)###-###',
  },
  {
    name: 'Maldives',
    iso: '+960',
    countryCode: 'MV',
    mask: '###-####',
  },
  {
    name: 'Mali',
    iso: '+223',
    countryCode: 'ML',
    mask: '##-##-####',
  },
  {
    name: 'Malta',
    iso: '+356',
    countryCode: 'MT',
    mask: '####-####',
  },
  {
    name: 'Marshall Islands',
    iso: '+692',
    countryCode: 'MH',
    mask: '###-####',
  },
  {
    name: 'Martinique',
    iso: '+596',
    countryCode: 'MQ',
    mask: '(###)##-##-##',
  },
  {
    name: 'Mauritania',
    iso: '+222',
    countryCode: 'MR',
    mask: '##-##-####',
  },
  {
    name: 'Mauritius',
    iso: '+230',
    countryCode: 'MU',
    mask: '###-####',
  },
  {
    name: 'Mayotte',
    iso: '+262',
    countryCode: 'YT',
    mask: '(###)###-####',
  },
  {
    name: 'Mexico',
    iso: '+52',
    countryCode: 'MX',
    mask: '(###)###-####',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    iso: '+691',
    countryCode: 'FM',
    mask: '###-####',
  },
  {
    name: 'Moldova',
    iso: '+373',
    countryCode: 'MD',
    mask: '####-####',
  },
  {
    name: 'Monaco',
    iso: '+377',
    countryCode: 'MC',
    mask: '(###)###-###',
  },
  {
    name: 'Mongolia',
    iso: '+976',
    countryCode: 'MN',
    mask: '##-##-####',
  },
  {
    name: 'Montenegro',
    iso: '+382',
    countryCode: 'ME',
    mask: '##-###-###',
  },
  {
    name: 'Montserrat',
    iso: '+1(664)',
    countryCode: 'MS',
    mask: '###-####',
  },
  {
    name: 'Morocco',
    iso: '+212',
    countryCode: 'MA',
    mask: '##-####-###',
  },
  {
    name: 'Mozambique',
    iso: '+258',
    countryCode: 'MZ',
    mask: '##-###-###',
  },
  {
    name: 'Myanmar',
    iso: '+95',
    countryCode: 'MM',
    mask: '##-###-###',
  },
  {
    name: 'Namibia',
    iso: '+264',
    countryCode: 'NA',
    mask: '##-###-####',
  },
  {
    name: 'Nauru',
    iso: '+674',
    countryCode: 'NR',
    mask: '###-####',
  },
  {
    name: 'Nepal',
    iso: '+977',
    countryCode: 'NP',
    mask: '##-###-###',
  },
  {
    name: 'Netherlands',
    iso: '+31',
    countryCode: 'NL',
    mask: '##-###-####',
  },
  {
    name: 'Netherlands Antilles',
    iso: '+599',
    countryCode: 'AN',
    mask: '###-####',
  },
  {
    name: 'New Caledonia',
    iso: '+687',
    countryCode: 'NC',
    mask: '##-####',
  },
  {
    name: 'New Zealand',
    iso: '+64',
    countryCode: 'NZ',
    mask: '(###)###-###',
  },
  {
    name: 'Nicaragua',
    iso: '+505',
    countryCode: 'NI',
    mask: '####-####',
  },
  {
    name: 'Niger',
    iso: '+227',
    countryCode: 'NE',
    mask: '##-##-####',
  },
  {
    name: 'Nigeria',
    iso: '+234',
    countryCode: 'NG',
    mask: '(###)###-####',
  },
  {
    name: 'Niue',
    iso: '+683',
    countryCode: 'NU',
    mask: '####',
  },
  {
    name: 'Norfolk Island',
    iso: '+672',
    countryCode: 'NF',
    mask: '###-###',
  },
  {
    name: 'Northern Mariana Islands',
    iso: '+1(670)',
    countryCode: 'MP',
    mask: '###-####',
  },
  {
    name: 'Norway',
    iso: '+47',
    countryCode: 'NO',
    mask: '(###)##-###',
  },
  {
    name: 'Oman',
    iso: '+968',
    countryCode: 'OM',
    mask: '##-###-###',
  },
  {
    name: 'Pakistan',
    iso: '+92',
    countryCode: 'PK',
    mask: '(###)###-####',
  },
  {
    name: 'Palau',
    iso: '+680',
    countryCode: 'PW',
    mask: '###-####',
  },
  {
    name: 'Palestinian Territory, Occupied',
    iso: '+970',
    countryCode: 'PS',
    mask: '##-###-####',
  },
  {
    name: 'Panama',
    iso: '+507',
    countryCode: 'PA',
    mask: '###-####',
  },
  {
    name: 'Papua New Guinea',
    iso: '+675',
    countryCode: 'PG',
    mask: '(###)##-###',
  },
  {
    name: 'Paraguay',
    iso: '+595',
    countryCode: 'PY',
    mask: '(###)###-###',
  },
  {
    name: 'Peru',
    iso: '+51',
    countryCode: 'PE',
    mask: '(###)###-###',
  },
  {
    name: 'Philippines',
    iso: '+63',
    countryCode: 'PH',
    mask: '(###)###-####',
  },
  {
    name: 'Pitcairn',
    iso: '+64',
    countryCode: 'PN',
    mask: '(###) ###-####',
  },
  {
    name: 'Poland',
    iso: '+48',
    countryCode: 'PL',
    mask: '(###)###-###',
  },
  {
    name: 'Portugal',
    iso: '+351',
    countryCode: 'PT',
    mask: '##-###-####',
  },
  {
    name: 'Puerto Rico',
    iso: '+1939',
    countryCode: 'PR',
    mask: '(###) ###-####',
  },
  {
    name: 'Qatar',
    iso: '+974',
    countryCode: 'QA',
    mask: '####-####',
  },
  {
    name: 'Romania',
    iso: '+40',
    countryCode: 'RO',
    mask: '##-###-####',
  },
  {
    name: 'Russia',
    iso: '+7',
    countryCode: 'RU',
    mask: '(###)###-##-##',
  },
  {
    name: 'Rwanda',
    iso: '+250',
    countryCode: 'RW',
    mask: '(###)###-###',
  },
  {
    name: 'Reunion',
    iso: '+262',
    countryCode: 'RE',
    mask: '#####-####',
  },
  {
    name: 'Saint Barthelemy',
    iso: '+590',
    countryCode: 'BL',
    mask: '(###) ###-####',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    iso: '+290',
    countryCode: 'SH',
    mask: '####',
  },
  {
    name: 'Saint Kitts and Nevis',
    iso: '+1(869)',
    countryCode: 'KN',
    mask: '###-####',
  },
  {
    name: 'Saint Lucia',
    iso: '+1(758)',
    countryCode: 'LC',
    mask: '###-####',
  },
  {
    name: 'Saint Martin',
    iso: '+590',
    countryCode: 'MF',
    mask: '(###) ###-####',
  },
  {
    name: 'Saint Pierre and Miquelon',
    iso: '+508',
    countryCode: 'PM',
    mask: '(###) ###-####',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    iso: '+1(784)',
    countryCode: 'VC',
    mask: '###-####',
  },
  {
    name: 'Samoa',
    iso: '+685',
    countryCode: 'WS',
    mask: '##-####',
  },
  {
    name: 'San Marino',
    iso: '+378',
    countryCode: 'SM',
    mask: '####-######',
  },
  {
    name: 'Sao Tome and Principe',
    iso: '+239',
    countryCode: 'ST',
    mask: '##-#####',
  },
  {
    name: 'Saudi Arabia',
    iso: '+966',
    countryCode: 'SA',
    mask: '#-###-####',
  },
  {
    name: 'Senegal',
    iso: '+221',
    countryCode: 'SN',
    mask: '##-###-####',
  },
  {
    name: 'Serbia',
    iso: '+381',
    countryCode: 'RS',
    mask: '##-###-####',
  },
  {
    name: 'Seychelles',
    iso: '+248',
    countryCode: 'SC',
    mask: '#-###-###',
  },
  {
    name: 'Sierra Leone',
    iso: '+232',
    countryCode: 'SL',
    mask: '##-######',
  },
  {
    name: 'Singapore',
    iso: '+65',
    countryCode: 'SG',
    mask: '####-####',
  },
  {
    name: 'Slovakia',
    iso: '+421',
    countryCode: 'SK',
    mask: '(###)###-###',
  },
  {
    name: 'Slovenia',
    iso: '+386',
    countryCode: 'SI',
    mask: '##-###-###',
  },
  {
    name: 'Solomon Islands',
    iso: '+677',
    countryCode: 'SB',
    mask: '#####',
  },
  {
    name: 'Somalia',
    iso: '+252',
    countryCode: 'SO',
    mask: '#-###-###',
  },
  {
    name: 'South Africa',
    iso: '+27',
    countryCode: 'ZA',
    mask: '##-###-####',
  },
  {
    name: 'South Sudan',
    iso: '+211',
    countryCode: 'SS',
    mask: '##-###-####',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    iso: '+500',
    countryCode: 'GS',
    mask: '(###) ###-####',
  },
  {
    name: 'Spain',
    iso: '+34',
    countryCode: 'ES',
    mask: '(###)###-###',
  },
  {
    name: 'Sri Lanka',
    iso: '+94',
    countryCode: 'LK',
    mask: '##-###-####',
  },
  {
    name: 'Sudan',
    iso: '+249',
    countryCode: 'SD',
    mask: '##-###-####',
  },
  {
    name: 'Suriname',
    iso: '+597',
    countryCode: 'SR',
    mask: '###-####',
  },
  {
    name: 'Svalbard and Jan Mayen',
    iso: '+47',
    countryCode: 'SJ',
    mask: '(###) ###-####',
  },
  {
    name: 'Swaziland',
    iso: '+268',
    countryCode: 'SZ',
    mask: '##-##-####',
  },
  {
    name: 'Sweden',
    iso: '+46',
    countryCode: 'SE',
    mask: '##-###-####',
  },
  {
    name: 'Switzerland',
    iso: '+41',
    countryCode: 'CH',
    mask: '##-###-####',
  },
  {
    name: 'Syrian Arab Republic',
    iso: '+963',
    countryCode: 'SY',
    mask: '##-####-###',
  },
  {
    name: 'Taiwan',
    iso: '+886',
    countryCode: 'TW',
    mask: '####-####',
  },
  {
    name: 'Tajikistan',
    iso: '+992',
    countryCode: 'TJ',
    mask: '##-###-####',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    iso: '+255',
    countryCode: 'TZ',
    mask: '##-###-####',
  },
  {
    name: 'Thailand',
    iso: '+66',
    countryCode: 'TH',
    mask: '##-###-###',
  },
  {
    name: 'Timor-Leste',
    iso: '+670',
    countryCode: 'TL',
    mask: '###-####',
  },
  {
    name: 'Togo',
    iso: '+228',
    countryCode: 'TG',
    mask: '##-###-###',
  },
  {
    name: 'Tokelau',
    iso: '+690',
    countryCode: 'TK',
    mask: '####',
  },
  {
    name: 'Tonga',
    iso: '+676',
    countryCode: 'TO',
    mask: '#####',
  },
  {
    name: 'Trinidad and Tobago',
    iso: '+1(868)',
    countryCode: 'TT',
    mask: '###-####',
  },
  {
    name: 'Tunisia',
    iso: '+216',
    countryCode: 'TN',
    mask: '##-###-###',
  },
  {
    name: 'Turkey',
    iso: '+90',
    countryCode: 'TR',
    mask: '(###)###-####',
  },
  {
    name: 'Turkmenistan',
    iso: '+993',
    countryCode: 'TM',
    mask: '#-###-####',
  },
  {
    name: 'Turks and Caicos Islands',
    iso: '+1(649)',
    countryCode: 'TC',
    mask: '###-####',
  },
  {
    name: 'Tuvalu',
    iso: '+688',
    countryCode: 'TV',
    mask: '#####',
  },
  {
    name: 'Uganda',
    iso: '+256',
    countryCode: 'UG',
    mask: '(###) ###-###',
  },
  {
    name: 'Ukraine',
    iso: '+380',
    countryCode: 'UA',
    mask: '(##) ###-##-##',
  },
  {
    name: 'United Arab Emirates',
    iso: '+971',
    countryCode: 'AE',
    mask: '##-###-####',
  },
  {
    name: 'United Kingdom',
    iso: '+44',
    countryCode: 'GB',
    mask: '##-####-####',
  },
  {
    name: 'United States',
    iso: '+1',
    countryCode: 'US',
    mask: '(###)###-####',
  },
  {
    name: 'Uruguay',
    iso: '+598',
    countryCode: 'UY',
    mask: '#-###-##-##',
  },
  {
    name: 'Uzbekistan',
    iso: '+998',
    countryCode: 'UZ',
    mask: '##-###-####',
  },
  {
    name: 'Vanuatu',
    iso: '+678',
    countryCode: 'VU',
    mask: '##-#####',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    iso: '+58',
    countryCode: 'VE',
    mask: '(###)###-####',
  },
  {
    name: 'Vietnam',
    iso: '+84',
    countryCode: 'VN',
    mask: '(###)####-###',
  },
  {
    name: 'Virgin Islands, British',
    iso: '+1(284)',
    countryCode: 'VG',
    mask: '###-####',
  },
  {
    name: 'Virgin Islands, U.S.',
    iso: '+1(340)',
    countryCode: 'VI',
    mask: '###-####"',
  },
  {
    name: 'Wallis and Futuna',
    iso: '+681',
    countryCode: 'WF',
    mask: '##-####',
  },
  {
    name: 'Yemen',
    iso: '+967',
    countryCode: 'YE',
    mask: '##-###-###',
  },
  {
    name: 'Zambia',
    iso: '+260',
    countryCode: 'ZM',
    mask: '##-###-####',
  },
  {
    name: 'Zimbabwe',
    iso: '+263',
    countryCode: 'ZW',
    mask: '#-######',
  },
];

export default numbers;
